var map = {
	"./template.bet777": 1605,
	"./template.bet777.tsx": 1605,
	"./template.buffalobet": 1606,
	"./template.buffalobet.tsx": 1606,
	"./template.chromabet": 1607,
	"./template.chromabet.tsx": 1607,
	"./template.default": 668,
	"./template.default.tsx": 668,
	"./template.gigabet": 1608,
	"./template.gigabet.tsx": 1608,
	"./template.goldenbet888": 1609,
	"./template.goldenbet888.tsx": 1609,
	"./template.slambet": 1610,
	"./template.slambet.tsx": 1610,
	"./template.templebet": 1611,
	"./template.templebet.tsx": 1611,
	"./template.titanbet": 1612,
	"./template.titanbet.tsx": 1612,
	"./template.ts": 983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2445;